module.exports = __webpack_public_path__ + "img/sort-ascending-icons.759cdbf5.svg";